module.exports = __webpack_public_path__ + "img/Sectors_Overlap_in_Sectors.0771c7b2.jpg";